var kioskVisibility = (function(common){
    var isAdmin = (window.pfKioskAdmin !== undefined);
    var timestamp;
    var hidden, visibilityChange;
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }

    function onVisibilityChange() {
        if (document[hidden]) {
            timestamp = Date.now();
        } else {
            if(Date.now() - timestamp > 10000){
                common.showLoader();
                if(isAdmin){
                    pfKioskAdmin.reload = 'refocus';
                } else {
                    pfKiosk.reload = 'refocus';
                }
                window.location.reload(true);
            }
        }
    }

    if (typeof document.addEventListener !== "undefined" || hidden !== undefined) {
        document.addEventListener(visibilityChange, onVisibilityChange, false);
    }
    console.log('monitoring page visibility')
})(common);
